export default "__VITE_ASSET__CaYG75Yj__"